import { IShopItemDiscount } from "./types";

export const formatPrice = (price: number | string | undefined): string => {
  if (!price) return "0";
  return Math.floor(Number(price)).toLocaleString();
};

export const formatBalance = (balance: number | string | undefined): string => {
  const numericBalance = Number(balance);

  if (!Number.isFinite(numericBalance)) return "0";

  return numericBalance.toLocaleString(undefined, {
    maximumFractionDigits: 3,
  });
};

export const isActiveDiscount = (discount?: IShopItemDiscount): discount is IShopItemDiscount => {
  return Boolean(discount?.id && discount.status === "ACTIVE" && Number(discount.value) > 0);
};

export const getDiscountedPrice = (
  price: number | string | undefined,
  discount?: IShopItemDiscount
): number => {
  const numericPrice = Number(price);

  if (!Number.isFinite(numericPrice) || numericPrice <= 0) return 0;
  if (!isActiveDiscount(discount)) return numericPrice;

  const discountValue = Math.min(Math.max(Number(discount.value), 0), 100);
  const discountedPrice = numericPrice * (1 - discountValue / 100);

  if (discountedPrice <= 0) return 0;

  return Math.max(1, Math.ceil(discountedPrice));
};
